
import { Component, Vue, Watch } from "vue-property-decorator";
import { UserModule } from "../../store/modules/user";
import { IOrderColspan } from "@/types/order";
import {
  getDeviceList,
  addDevice,
  productList,
  editDevice,
  delDevice,
  batchQrCode,
  deviceLimit,
  impowerDevice,
  batchModifyDevice
} from "@/api/device";
import { getServiceList } from "../../api/service";
import { parseTime } from "@/utils";

import dialogImgLarge from "@/components/ImgLarge/index.vue";
import dialogDeviceRecord from "./components/DeviceRecord.vue";
import dialogDevice from "./components/DeviceDialog.vue";
import dialogSetImport from "../staff/components/setImport.vue";
import DialogCustomer from "@/components/CustomerDialog/levelByLevel.vue";
import { checkPermissionUseAndCompany } from "@/utils/permission";
import { Type } from "@/types/permissionType";
import searchForm from "./components/DeviceSearch.vue";
import DialogLveReportDept from '@/components/DeptLev/index.vue';

@Component({
  name: "DeviceToBrand",
  components: {
    dialogImgLarge,
    dialogDeviceRecord,
    dialogSetImport,
    dialogDevice,
    DialogCustomer,
    searchForm,
    DialogLveReportDept,
  },
  filters: {
    formatDate(val: string) {
      const t = new Date(parseInt(val));
      return parseTime(parseInt(val), "{y}-{m}-{d}");
    },
    formatType(val: string) {
      if (val === "5") {
        return "通知";
      } else {
        return "公告";
      }
    },
  },
})
export default class extends Vue {
  private deviceLimits: any = {
    device_number_limit: 0,
    already_add_device_number: 0,
  };
  private vipLevel: any = 0;
  private isShowDeviceHistry = false;
  private labelBrand = "品牌";
  private labelProduct = "类型";
  private labelModel = "型号";
  private deviceSearch = {}
  private servicerCompanyId='';
  created() {
    this.servicerCompanyId =  UserModule.getCompanyId;
    this.isShowDeviceHistry = checkPermissionUseAndCompany(
      UserModule.getCompanyId,
      Type.DeviceHistry
    );
    if (parseInt(UserModule.getCompanyId) !== 0 && UserModule.company) {
      this.vipLevel = parseInt(
        String((UserModule.company as any).vip_level).substring(0, 1)
      );
      if (UserModule.company.brand_name_alias) {
        this.labelBrand = UserModule.company.brand_name_alias;
      } else {
        this.labelBrand = "品牌";
      }
      if (UserModule.company.product_name_alias) {
        this.labelProduct = UserModule.company.product_name_alias;
      } else {
        this.labelProduct = "类型";
      }
      if (UserModule.company.model_name_alias) {
        this.labelModel = UserModule.company.model_name_alias;
      } else {
        this.labelModel = "型号";
      }
    }
    this.deviceLimit();
    this.getDeviceList();
  }
  // 全选
  handleCheckAllChange(val: boolean) {
    this.selectedbox = val ? this.tableData : [];
    this.isIndeterminate = false;
  }

  handlePageSizeChange(val: number) {
    this.pagination.currentPage = 1;
    this.pagination.pageSize = val;
  }
  handleCurrentChange(val: number) {
    this.pagination.currentPage = val;
  }
  private deviceLimit() {
    const params = {
      company_id: UserModule.getCompanyId,
    };
    deviceLimit(params).then((res) => {
      this.deviceLimits = res.data;
    });
  }
  deviceSearchHandle(val: any) {
    this.deviceSearch = val;
    if (val) {
      //重置页码到1
      this.pagination.currentPage = 1;
      this.getDeviceList()
    }
  }
  getDeviceList() {
    this.selectedbox = [];
    this.isIndeterminate = false;
    let params: any = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      ...this.deviceSearch
    };
    getDeviceList(params)
      .then((res) => {
        if (res && res.data) {
          if (res.data.count) {
            this.pagination.total = res.data.count;
          } else {
            this.pagination.total = 0;
          }

          this.tableData = res.data.list;
        }
      })
      .catch((err) => {
        this.pagination.total = 0;
        this.tableData = [];
        let msg = err.msg;
      });
  }

  private tableData = [];
  private selectedbox = [];
  private checkAll = false;
  private isIndeterminate: any = null;
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0,
  };
  @Watch("pagination", {
    deep: true,
    immediate: true,
  })
  handlePageChange() {
    this.getDeviceList();
  }

  private dialogAddDeviceVisible = false;
  private dialogSettingItemVisible = false;
  private tableDataSettingItem = [];

  handleSelectionChange(value: any) {
    let checkedCount = value.length;
    this.checkAll = checkedCount === this.tableData.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.tableData.length;
  }

  // 删除设备
  private delDevice(val: any) {
    this.deviceId = val.id;
    let params: any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    params.device_id = this.deviceId;
    this.$confirm(`确定删除此设备吗?`, {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then((res) => {
        delDevice(params)
          .then((res) => {
            this.showSecussMsg((res as any).msg);
            this.getDeviceList();
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }
  // 编辑设备
  // private deviceEditData = {}
  editHandle(val: any) {
    this.$router.push({
      path: "addDevice",
      query: {
        formEdit: JSON.stringify(val),
        deviceLimits: JSON.stringify(this.deviceLimits),
      },
    });
  }
  private deviceId: string = "";
  private addDeviceClick() {
    this.$router.push({
      path: "addDevice",
      query: { deviceLimits: JSON.stringify(this.deviceLimits) },
    });
  }
  private closeDevice(val: boolean) {
    this.dialogAddDeviceVisible = val;
  }

  // 设备履历
  private dialogDeviceRecordVisible = false;
  private rowData: any = "";
  recordHandle(val: any) {
    this.rowData = val;
    this.rowData.device_id = val.id;
    this.dialogDeviceRecordVisible = true;
  }
  closeRecordHandle(value: boolean) {
    this.dialogDeviceRecordVisible = value;
  }
  // 导入设备
  private setImportVisible = false;
  private setImportTitle = "导入设备";
  private improtInDevice() {
    this.setImportVisible = true;
  }
  closeImport(value: boolean) {
    this.getDeviceList();
    this.setImportVisible = value;
  }
  // 导出二维码
  private improtOutQr() {
    if (!this.selectedbox || this.selectedbox.length < 1) {
      this.$notify.warning({
        title: "提示",
        message: "请选择设备",
      });
      return;
    }
    let id = "";
    for (var item of this.selectedbox) {
      id = id + (item as any).id + ",";
    }
    let params: any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    params.id = id.substring(0, id.length - 1);
    batchQrCode(params)
      .then((res) => {})
      .catch((err) => {
        if (!err.msg) {
          let blob = new Blob([err]);
          let fileName = new Date().getTime() + ".pdf";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            let elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            // navigator.msSaveBlob(blob, fileName);
          }
          this.$message.success("下载文件成功");
        } else {
          this.$message.error(err.msg);
        }
      });
  }

  private dropdownHandle(name: any) {
    let funcname: any = this.$options.methods;
    funcname[name].bind(this)();
  }

  // 授权客户
  private dialogAuthCustomerVisible = false;
  private formAuthCustomer: any = {
    customer: {},
    start: "",
    period: "",
    original: "",
    authServer: {},
  };
  private authCustomerHandle() {
    if (this.selectedbox.length > 0) {
      if (this.vipLevel === 1) {
        this.getServerList();
      }
      this.dialogAuthCustomerVisible = true;
    } else {
      this.$notify({
        title: "提示",
        message: "请选择设备",
        type: "warning",
      });
    }
  }

  private customerVisible = false;
  private editCustomerData = {};

  private authServerList: any = [];

  private getServerList() {
    let params: any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    getServiceList(params)
      .then((res) => {
        if (res.data) {
          this.authServerList = res.data.list;
        }
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }

  private selectedAuth() {
    if (this.vipLevel !== 1) {
      this.customerVisible = true;
    }
  }
  private customerClose(val: boolean) {
    this.customerVisible = val;
  }
  private customerConfirm(val: any) {
    this.formAuthCustomer.customer = val;
  }
  private finishAuth() {
    if (this.vipLevel === 1) {
      if (
        !this.formAuthCustomer.authServer ||
        !this.formAuthCustomer.authServer.id
      ) {
        this.showErrorMsg("请选择服务方");
        return;
      }
    } else {
      if (
        !this.formAuthCustomer.customer ||
        !this.formAuthCustomer.customer.customer_type
      ) {
        this.showErrorMsg("请选择客户");
        return;
      }
    }
    let pamars: any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    let deviceId = "";
    for (var device of this.selectedbox) {
      deviceId = deviceId + (device as any).id + ",";
    }
    pamars.device_id = deviceId.substring(0, deviceId.length - 1);

    if (
      this.formAuthCustomer.customer &&
      this.formAuthCustomer.customer.customer_type
    ) {
      if (parseInt(this.formAuthCustomer.customer.customer_type) === 1) {
        pamars.to_company_id =
          this.formAuthCustomer.customer.customer_company_id;
      } else {
        pamars.to_company_id =
          "p" + this.formAuthCustomer.customer.customer_user_id;
      }
    } else {
      pamars.to_company_id = this.formAuthCustomer.authServer.id;
    }

    pamars.start_time = this.formAuthCustomer.start;
    pamars.warranty = this.formAuthCustomer.period;
    pamars.impower_type = this.vipLevel === 1 ? "" : "customer";
    if (this.vipLevel !== 1) {
      pamars.manufacturer_warranty_state = this.formAuthCustomer.original
        ? "1"
        : "0";
    }

    impowerDevice(pamars)
      .then((res: any) => {
        this.showSecussMsg(res.msg);
        this.dialogAuthCustomerVisible = false;
        this.getDeviceList();
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  // groupDeleteHandle批量删除
  private groupDeleteHandle() {
    if (!this.selectedbox || this.selectedbox.length < 1) {
      this.showErrorMsg("请选择设备");
      return;
    }
    let deviceId = "";
    for (var device of this.selectedbox) {
      deviceId = deviceId + (device as any).id + ",";
    }
    this.$confirm(
      "删除设备会将设备下的授权关系全部删除！",
      `确认删除这些设备?`,
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    )
      .then((res) => {
        let params: any = {};
        params.company_id = UserModule.getCompanyId;
        params.user_id = UserModule.getUserId;
        params.device_id = deviceId.substring(0, deviceId.length - 1);
        delDevice(params)
          .then((res) => {
            this.showSecussMsg((res as any).msg);
            this.getDeviceList();
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }

  checkItemHandle(val: any) {
    this.dialogSettingItemVisible = true;
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: index,
    };
    this.$store.dispatch("toggleEnlarged", enlargedData);
  }

  private originalChange(val: any) {
    if (val) {
      let arr = this.selectedbox.filter((device: any) => {
        return device.manufacturer_phone === "";
      });
      if (arr && arr.length > 0) {
        this.showErrorMsg("请在编辑设备中先填写设备的厂商信息,再开启原厂保修");
        this.$set(this.formAuthCustomer, "original", false);
      }
    }
  }

  //选择部门 批量设置部门
  private departmentLevVisible=false
  private departmentLevSelect={id:0,name:''}
  private selectReportDept() {
    //判断是否选择
    if (!this.selectedbox || this.selectedbox.length < 1) {
      this.showErrorMsg("请选择设备");
      return;
    }
    this.departmentLevVisible = true;
  }
  private selectDeptLev(value:any) {
    // this.formAdd.userDept = value;
    //记录选中 
    this.departmentLevSelect = value;
    
  }
  private handleLveReportDeptConfirm() {
    let deviceId = "";
    for (var device of this.selectedbox) {
      deviceId = deviceId + (device as any).id + ",";
    }

    let params: any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    params.device_id = deviceId.substring(0, deviceId.length - 1);
    params.dept_id = this.departmentLevSelect.id ;
    params.dept_name = this.departmentLevSelect.name ;
    batchModifyDevice(params)
      .then((res) => {
        this.showSecussMsg((res as any).msg);
        this.getDeviceList();
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });

    this.departmentLevVisible = false;
    this.departmentLevSelect = {id:0,name:''};

  }
  private closeDialogLveReportDept() {
    this.departmentLevVisible = false;
    this.departmentLevSelect = {id:0,name:''};
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: "notification-center",
      type: "success",
    });
  }
}
